module.exports = __webpack_public_path__ + "img/about_heart.dd7f7e5b.png";